export const checkAndFixBroCode = () => {
  const storedBroCode = localStorage.getItem('brocode') || localStorage.getItem('user_brocode');
  
  console.log('🔍 [BROCODE_CHECK] Current BroCode in localStorage:', storedBroCode);
  console.log('🔍 [BROCODE_CHECK] All localStorage keys:', Object.keys(localStorage));
  
  // If no BroCode found or incorrect one, let's check the wallet
  if (!storedBroCode || storedBroCode === 'npcdrip-6250') {
    const walletAddress = localStorage.getItem('connected_wallet_address') || 
                         localStorage.getItem('bromentum_wallet_address') || 
                         localStorage.getItem('walletAddress');
    
    console.log('🔍 [BROCODE_CHECK] Found wallet address:', walletAddress);
    
    // The user should be using NPCDRIP-6230 based on the wallet 0x26732990f32762213e263caf4899addb47c96230
    if (walletAddress?.toLowerCase().includes('6230')) {
      console.log('✅ [BROCODE_CHECK] Setting correct BroCode: NPCDRIP-6230');
      localStorage.setItem('brocode', 'NPCDRIP-6230');
      localStorage.setItem('user_brocode', 'NPCDRIP-6230');
      return 'NPCDRIP-6230';
    }
  }
  
  return storedBroCode;
};